{
  "backgroundColor": "#111111b3",
  "tooltip": {
    "trigger": "item",
    "formatter": "{a} <br/>{b}: {c} Hunts"
  },
  "series": {
    "name": null,
    "radius": ["15%", "90%"],
    "type": "sunburst",
    "emphasis": {
      "focus": "ancestor"
    },
    "data": [],
    "label": {
      "rotate": "radial"
    },
    "levels": [],
    "itemStyle": {
      "color": "#ddd",
      "borderWidth": 2,
      "borderRadius": 5
    }
  },
  "graphic": {
    "elements": [
      {
        "type": "text",
        "left": "center",
        "top": "center",
        "style": {
          "text": "replace",
          "textAlign": "center",
          "fill": "#111111b3",
          "fontSize": 20,
          "fontWeight": "bold"
        }
      },
      {
        "type": "text",
        "left": "center",
        "bottom": 20,
        "style": {
          "text": "replace",
          "textAlign": "center",
          "fill": "#111111b3",
          "fontSize": 16,
          "fontWeight": "bold"
        }
      }
    ]
  }
}
